import { render, staticRenderFns } from "./ProductVariantItem.vue?vue&type=template&id=23f03986&scoped=true&"
import script from "./ProductVariantItem.vue?vue&type=script&lang=js&"
export * from "./ProductVariantItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductVariantItem.vue?vue&type=style&index=0&id=23f03986&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f03986",
  null
  
)

export default component.exports